export type Modality = 'EAD' | 'SEMI';

export interface Course {
  id?: number;
  name?: string;
  type?: string;
  duration?: string;
  isAvailable?: boolean;
  // Modalidade em que o curso é ofertado (`SEMI`, `PRESENCIAL` ou `EAD`).
  modality?: string;
}

export interface CourseState {
  course?: Course;
  availableCourses?: Course[];
  modality: Modality;
}

const course: CourseState = {
  course: undefined,
  availableCourses: [],
  modality: 'EAD',
};

export default course;
